import { render, staticRenderFns } from "./insideUrl.vue?vue&type=template&id=381435c2"
import script from "./insideUrl.vue?vue&type=script&lang=js"
export * from "./insideUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports